module.exports = {
  baseUrl:process.env.VUE_APP_BASE_URL ||'https://iig-chat-ttb-api-prd.herokuapp.com',
  submitSurveyEndpoint:process.env.VUE_APP_SUBMIT_SURVEY_ENDPOINT || '/webchat/submitsurvey',
  checkAgentEndpoint:process.env.VUE_APP_CHECK_AGENT_ENDPOINT || '/webchat/agent/status',
  pusherId: process.env.VUE_APP_PUSHER_ID || '867d8ce32bcd17f388e8',
  cluster: process.env.VUE_APP_AUTH_CLUSTER || 'mt1',
  checksurveyexpireEndpoint: process.env.VUE_APP_CHECK_SURVEY_EXPIRE_ENDPOINT ||'/webchat/checksurveyexpire',
}
